<template>
    <div class="hum-container">
        <div class="v-head-container">
            <div class="v-left-head-container" @click="vBackHome">
                <svg t="1766639305795"  class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="v-right-head-container">{{videoInfo.title}}</div>
            <div class="v-left-head-container">
            </div>
        </div>
        <div class="video-container">
            <div class="v-l-container">
                <div class="v-icon cursor" @click="viewFile">
                    <img style="width: 30px;" src="../../assets/image/video-file.png" alt="">
                    <div style="text-align: center;margin-top: 5px;">资料</div>
                </div>
            </div>
            <div class="v-r-container">
                <div id="playerkxj"></div>
            </div>
        </div>
    </div>

    <el-dialog draggable :title="'资料'" v-model="isFileShow" width="50%">
        <div style="display: flex;flex-wrap: wrap;">
            <div style="margin: 15px;" v-for="item in fileList" class="csbbb mb10 cursor">
                <el-icon :size="20" v-has-btn="'1,2'" @click.stop="handleDownload(item)" title="下载" class="eicon"
                         style="right: 15px;top: 5px;cursor: pointer;z-index: 99;">
                    <Download />
                </el-icon>
                <img style="width: 250px;height:300px;object-fit: cover;" :src="item.imgUrl + '/1.png'" alt="">
                <div style="text-align: center;width: 250px;" :title="item.fileName" class="text-one">{{ item.fileName
                    }}</div>
            </div>
        </div>
        <div style="width: 100%;" v-if="fileList.length === 0">
            <el-empty class="qun-empty" description="暂无附件" />
        </div>
    </el-dialog>
</template>

<script>
import { timestampToTime } from "@/utils/date";
import {serviceWebUrl} from "@/utils/global";
import {infoHumanityVideo} from "@/api/admin/humanity"
import {download} from "@/api/adminservice/public";
export default {
    name: "humVideoKxjPlayer",
    components: {},
    props:{
        videoId:{
            type: String,
            default:null
        },
    },
    watch:{
        videoId(newValue,oldValue){
            this.vid = newValue.split("&")[0];
            this.queryHumanityVideo()
        },
    },
    data() {
        return {
            timestampToTime,
            isFileShow:false,
            isLogin:this.$storage.get('isLogin'),
            vodPlayerJs: 'https://player.polyv.net/resp/vod-player/latest/player.js',
            vid:'',
            videoInfo:{},
            fileList:[],
            commentList:[],
            content:"",
        };
    },
    created() {
    },
    mounted() {
    },
    computed: {},
    methods: {
        queryHumanityVideo() {
            infoHumanityVideo({ videoId: this.vid }).then(res => {
                if (res.data.code === 1) {
                    this.videoInfo = res.data.data;
                    this.fileList = this.videoInfo.fileList
                    this.viewVideo();
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        viewVideo(){
            setTimeout(() => {
                this.loadPlayerScript(this.loadPlayer);
            })
        },
        loadPlayerScript(callback) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script');
                myScript.setAttribute('src', this.vodPlayerJs);
                myScript.onload = callback;
                document.body.appendChild(myScript);
            } else {
                callback();
            }
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer;
            this.player = polyvPlayer({
                wrap: '#playerkxj',
                vid: this.videoInfo.videoId,
            });
        },
        destroyed() {
            if (this.player) {
                this.player.destroy();
            }
        },
        userToLogin(){
            //参数传递
            const link = serviceWebUrl+'/teaching/officeLink?vid='+this.videoId
            this.$router.push({
                path: '/login',
                query: {
                    callback: link,
                }
            });
        },
        handleDownload(item) {
            download(item.fileUrl, item.fileName)
        },
        viewFile() {
            this.isFileShow = true;
        },
        vBackHome(){
            this.destroyed();
            this.$emit('change-kxj-mode',"");
        }
    },
}

</script>

<style scoped>
.hum-container{
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-image: url("../../assets/img/bydyw_bg.png");
    background-repeat:no-repeat;
    background-size: 100% 100%;
    border-radius: 28px;
}
.v-head-container{
    width: 1000px;
    height: 44px;
    display: flex;
    margin: auto;
    border-bottom: 1px solid #f1f1f1;
}
.v-left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.v-right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}
.video-container{
    width: 1000px;
    height: calc(100vh - 120px);
    margin: auto;
    display: flex;
}
.v-l-container{
    width: 100px;
    height: calc(100vh - 120px);
    border-right: 1px solid #f1f1f1;
}
.v-icon{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 10px
}
.v-r-container{
    width: calc(100% - 102px);
    height: calc(100vh - 120px);
    padding: 10px 20px 10px 10px;
    box-sizing: border-box;
}
</style>